export function SmartphoneMockup() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Phone Mockup */}
          <div className="flex-1 flex justify-center">
            <div className="relative">
              {/* Phone Frame */}
              <div className="bg-gray-900 rounded-[3rem] p-2 shadow-2xl w-fit">
                <div className="bg-white rounded-[2.5rem] overflow-hidden relative">
                  {/* App Recording GIF */}
                  <img 
                    src="/app-demo.gif" 
                    alt="Locale App Demo" 
                    className="w-72 md:w-80 h-auto block"
                  />
                </div>
              </div>
            </div>
          </div>
          
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-poppins text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Discover what's happening{' '}
              <span className="text-locale-primary">right now</span> in your neighborhood
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              From spontaneous coffee meetups to last-minute happy hour deals, Locale keeps you connected to the pulse of your community in real-time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}